import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

import { usersList_template } from "../components/templates/usersList_template";

declare var ko: any;
declare var page: any;

export class users extends vnModule_knockoutJS{

    protected XHRHdl: XMLHttpRequestHandler;
    protected elementsList: usersList_template;

    protected getModuleName(){

        return "users";
    }

    buildContent() : Array<Element>{

        // create the users list
        this.elementsList = new usersList_template("list", this.viewModel, this);

        return [this.elementsList.build()];
    }

    public fillPage() : void{

        this.getFormData();
    }

    protected getFormData() {

        let token: string;
        let action: string;


        let validateReq_url: string = '/api/users/references/';
        let validateReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(validateReq_url, validateReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();

    }

    protected onGetFormDataReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                let userRoles = [{ id: '', name: "All"}];

                for (let role of responseParsed.roles) {
                    userRoles.push({id: role.id, name: role.name});
                }

                obj.elementsList.roleFilter.setOptions(userRoles);
                obj.elementsList.roleFilter.setLabel("Access Type");
                obj.elementsList.setPermissions(responseParsed.permissions)

                obj.filterList();
            });
        }
    }

    protected editUser(id){

        this.saveViewModule(this.elementsList.getViewModelForRequest());
        page('/user/edit/'+id);
    }

    protected viewUserProfile(id){

        this.saveViewModule(this.elementsList.getViewModelForRequest());
        page('/user/profile/'+id);
    }

    protected earningsUser(id){

        this.saveViewModule(this.elementsList.getViewModelForRequest());
        page('/payment/earnings/'+id);
    }

    protected addUser(){

        this.saveViewModule(this.elementsList.getViewModelForRequest());
        page('/user/add');
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected userListReorder(){

        this.filterList();
    }

    protected filterSimpleOnChange(){

        // on keywords filtering, always set the page back to 1.
        this.elementsList.pagination.getTemplateViewModel().pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange() {

        this.filterList();
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.elementsList.builtTemplate.children.namedItem("list-results"));

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        let usrReq_url: string = '/api/user/list/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.elementsList.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        let localCheck = this.XHRHdl.requestId;
        let _myThis = this;
        setTimeout(function(){

            if( localCheck == _myThis.XHRHdl.requestId ){
                _myThis.XHRHdl.onReadyStateFunction = _myThis.onFilterRequestReturn;
                _myThis.XHRHdl.execute();
            }
        }, 400);
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.updateList(responseParsed.data);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.loadingOut(obj.elementsList.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    //
    // update the module list using the objects list
    protected updateList(responseParsed: any){

        // set users list
        let usersToSet = [];
        console.log(responseParsed.users);
        for (let item of responseParsed.users) {

            usersToSet.push( {
                 pictureUrl:  ((item.vnAppUser.pictureUrl) ? "/usersImages/" + item.vnAppUser.pictureUrl : "/assets/images/default-user.png")
                ,firstName: item.vnAppUser.firstName
                ,lastName: item.vnAppUser.lastName
                ,loginName: item.vnAppUser.loginName
                ,email: item.vnAppUser.email
                ,dateCreation : item.vnAppUser.dateCreation.substring(0,10)
                ,id : item.id
            } )
        }

        this.elementsList.setUsers(usersToSet);

        // update the pagination
        this.viewModel.list.pagination.itemCount(responseParsed.usersCount);
    }

    protected onUpdateError(requestStatus: any, responseParsed) : void{

        let msg = "error: while retrieving the data";
        this.elementsList.validationsList.setSingleMessage({field: "error", "label": "code " + requestStatus, message: responseParsed.message});
        window.scrollTo(0, 0);
    }

    public filterSimpleCancel(): void {
        console.log('filterSimpleCancel');
    }
}



// WEBPACK FOOTER //
// ./js/modules/users.ts